import React from 'react';
import LeftNav from './LeftNav';
import VideoCard from "./VideoCard";
import { Context } from '../context/contextapi';
import { useContext, useEffect } from 'react';
 
const Feed = ()=>{
 const {loading , searchResults} =useContext(Context);
 console.log(searchResults);

  useEffect(()=>{
    document.getElementById("root").classList.remove("custom-h");
  },[]);

  return (
    <div className='flex flex-row h-[calc(100%-56px)] '>
      <LeftNav/>
      <div className='grow w-[calc(100%-240px)] h-full overflow-y-auto bg-white dark:bg-black'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 p-5 pl-240px' >
        {!loading &&
                        searchResults.map((item, index) => {
                            if (item.type !== "video") return false;
                            return (
                                <VideoCard
                                    key={index}
                                    video={item?.video}
                                />
                            );
                        })}
        </div>
      </div>
    </div>
  )
}

export default Feed